export default __webpack_public_path__ + "static/media/Annual-Earning.86148562.svg";